enum FilterLogicalOperator {
  AND = 'and',
  OR = 'or',
  NOT = 'not',
}

export default FilterLogicalOperator;
